module.exports = __webpack_public_path__ + "img/02.e154305.png";